<template>
  <div class="page-wrap">
    <Header></Header>

    <div class="apply-area flex-r-center">
      <div class="card-width">
        <el-card>
          <div slot="header" class="card-wrap flex-center-center fz24">
            <div
                class="tab-item tab-item-active"
            >
              数字证书在线申请
            </div>

            <div>{{ countdown }}</div>
          </div>

          <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="150px"
              class="demo-ruleForm"
              v-loading="loading"
          >
            <div class="upload-image">
              <div class="fz14 top-text">
                <div class="mb5" style="width: 100px">
                  <span style="color: red" class="mr5">*</span>上传材料：
                </div>
                <div class="fc-407FFF pointer" @click="checkExampleDia">查看示例</div>
                <!--                <div class="fc-407FFF pointer" @click="downAuth">下载授权书</div>-->
              </div>

              <div class="flex-center-wrap">
                <el-form-item label-width="0px" prop="businessLicenseId">
                  <el-input style="display: none" v-model="ruleForm.businessLicenseId"></el-input>
                  <el-upload
                      class="avatar-uploader"
                      multiple
                      :show-file-list="false"
                      :before-upload="(e) => handleBeforeUpload(e, 2)"
                      :on-change="onChangeFront"
                      action="/"
                      accept="image/*"
                  >
                    <img class="image-card" v-if="imageLicenseId" :src="imageLicenseId" alt/>
                    <img
                        class="icon-check"
                        v-if="imageLicenseId"
                        @click.stop="checkImage('license')"
                        src="@/assets/login/icon-check-img.png"
                        alt
                    />
                    <img
                        v-if="!imageLicenseId"
                        src="@/assets/login/image-card-official.png"
                        alt
                    />
                    <span v-if="!imageLicenseId" class="fz14 fc9">上传单位营业执照</span>
                  </el-upload>
                </el-form-item>

                <el-form-item label-width="0px" prop="operatorIdCardFront">
                  <el-input style="display: none" v-model="ruleForm.operatorIdCardFront"></el-input>
                  <el-upload
                      ref="operatorIdCardFront"
                      class="avatar-uploader"
                      multiple
                      :show-file-list="false"
                      :before-upload="(e) => handleBeforeUpload(e, 0)"
                      :on-change="onChangeFront"
                      action="/"
                      accept="image/*"
                  >
                    <div class="flex-dir-center-center" style="width: 100%;height: 100%"
                         @click.stop="changeUpload('operatorIdCardFront')">
                      <img class="image-card" v-if="imageUrlOperatorFront" :src="imageUrlOperatorFront" alt/>
                      <img
                          class="icon-check"
                          v-if="imageUrlOperatorFront"
                          @click.stop="checkImage('operatorFront')"
                          src="@/assets/login/icon-check-img.png"
                      />
                      <img v-if="!imageUrlOperatorFront" src="@/assets/login/image-card-people.png" alt/>
                      <span v-if="!imageUrlOperatorFront" class="fz14 fc9">上传经办人身份证人像面照片</span>
                    </div>
                  </el-upload>
                </el-form-item>

                <el-form-item label-width="0px" prop="operatorIdCardBack">
                  <el-input style="display: none" v-model="ruleForm.operatorIdCardBack"></el-input>
                  <el-upload
                      ref="operatorIdCardBack"
                      class="avatar-uploader"
                      multiple
                      :show-file-list="false"
                      :before-upload="(e) => handleBeforeUpload(e, 1)"
                      :on-change="onChangeReserve"
                      action="/"
                      accept="image/*"
                  >
                    <div class="flex-dir-center-center" style="width: 100%;height: 100%"
                         @click.stop="changeUpload('operatorIdCardBack')">
                      <img class="image-card" v-if="imageUrlOperatorReserve" :src="imageUrlOperatorReserve" alt/>
                      <img
                          class="icon-check"
                          v-if="imageUrlOperatorReserve"
                          @click.stop="checkImage('operatorFront')"
                          src="@/assets/login/icon-check-img.png"
                          alt
                      />
                      <img v-if="!imageUrlOperatorReserve" src="@/assets/login/image-card-emblem.png" alt/>
                      <span v-if="!imageUrlOperatorReserve" class="fz14 fc9">上传经办人身份证国徽面照片</span>
                    </div>
                  </el-upload>
                </el-form-item>

                <el-form-item label-width="0px" prop="authorizationId">
                  <el-input style="display: none" v-model="ruleForm.authorizationId"></el-input>
                  <el-upload
                      class="avatar-uploader"
                      multiple
                      :show-file-list="false"
                      :before-upload="(e) => handleBeforeUpload(e, 3)"
                      :on-change="onChangeReserve"
                      action="/"
                      accept="image/*"
                  >
                    <img class="image-card" v-if="imageAuthorization" :src="imageAuthorization" alt/>
                    <img
                        class="icon-check"
                        v-if="imageAuthorization"
                        @click.stop="checkImage('auth')"
                        src="@/assets/login/icon-check-img.png"
                        alt
                    />
                    <img v-if="!imageAuthorization" src="@/assets/login/image-card-emblem.png" alt/>
                    <span v-if="!imageAuthorization" class="fz14 fc9"
                    >上传授权委托书照片</span>
                  </el-upload>
                </el-form-item>

                <el-form-item label-width="0px" prop="digitalCertificateApplyForm">
                  <el-input style="display: none" v-model="ruleForm.digitalCertificateApplyForm"></el-input>
                  <el-upload
                      class="avatar-uploader"
                      multiple
                      :show-file-list="false"
                      :before-upload="(e) => handleBeforeUpload(e, 4)"
                      :on-change="onChangeReserve"
                      action="/"
                      accept="image/*"
                  >
                    <img class="image-card" v-if="imageDigitalCertificateApplyForm"
                         :src="imageDigitalCertificateApplyForm" alt/>
                    <img
                        class="icon-check"
                        v-if="imageDigitalCertificateApplyForm"
                        @click.stop="checkImage('auth')"
                        src="@/assets/login/icon-check-img.png"
                        alt
                    />
                    <img v-if="!imageDigitalCertificateApplyForm" src="@/assets/login/image-card-emblem.png" alt/>
                    <span v-if="!imageDigitalCertificateApplyForm" class="fz14 fc9"
                    >上传数字证书申请表</span>
                  </el-upload>
                </el-form-item>
              </div>

            </div>

            <el-row>
              <el-col :span="12">
                <el-form-item prop="operatorName" label="经办人姓名">
                  <el-input
                      v-model="ruleForm.operatorName"
                      placeholder="请输入经办人姓名"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="operatorId" label="经办人身份证号">
                  <el-input
                      v-model="ruleForm.operatorId"
                      placeholder="请输入经办人身份证号"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="operatorPhone" label="手机号码">
                  <el-input
                      type="number"
                      v-model="ruleForm.operatorPhone"
                      :maxlength="11"
                      placeholder="请输入手机号码"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label-width="0px">
              <el-button class="next-button" type="primary" @click="submitForm('ruleForm')"
              >申请
              </el-button
              >
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </div>

    <check-example ref="checkRef"></check-example>
    <!--    <face-check ref="faceRef" @subPersonSeal="getCheckId" @submitForm="submitForm"></face-check>-->
    <notice v-if="noticeVisible"
            :visible.sync="noticeVisible"/>

    <upload-change v-if="visible" :visible.sync="visible" :uploadType="uploadType" @uploadFiles="uploadFiles"/>
    <face-check ref="faceRef" @subPersonSeal="getCheckId"></face-check>
    <id-card-complete ref="IdCardComplete" @faceRecognition="faceRecognition"/>
    <Bottom></Bottom>
  </div>
</template>

<script>
import {defineComponent} from 'vue'
import CheckExample from "@/pages/register/components/CheckExample.vue";
import Header from "@/components/Header.vue";
import FaceCheck from "@/pages/register/physicsSeal/components/FaceCheck.vue";
import Bottom from "@/components/Bottom.vue";
import Cookies from "js-cookie";
import Notice from "@/pages/digitalCertificate/components/notice.vue";
import UploadChange from "@/pages/customerEnterprise/components/uploadChange.vue";
import IdCardComplete from "@/pages/customerEnterprise/components/idCardComplete.vue";

export default defineComponent({
  name: "index",
  components: {IdCardComplete, UploadChange, Notice, Bottom, FaceCheck, Header, CheckExample},
  data() {
    var validIdCard = (rule, value, callback) => {
      let reg = /^[1-9]\d{5}(?:18|19|20)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/;
      if (value === "") {
        callback(new Error("请输入身份证号"));
      } else if (!reg.test(value) && !this.disbaleList) {
        callback(new Error("请输入正确的身份证号"));
      } else {
        callback();
      }
    };
    var validPhone = (rule, value, callback) => {
      let reg = /^1[3456789]\d{9}$/;
      if (value === "") {
        callback(new Error("请输入实名手机号码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入实名手机号码"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      ruleForm: {
        caName: null,
        certType: "0",
        handlerName: "王楠",
        handlerId: "1234***4321",
        organizeName: null,
        organizeCode: null,
        certSubject: "C=CN,ST=辽宁省,L=大连市,0=测试员123456789123456789,0U=LNGSYZ,CN=测试123",
        tokenExpire: 1616
      },
      rules: {
        // operatorIdCardFront: [
        //   {
        //     required: true,
        //     message: "请上传经办人身份证人像面照片",
        //     trigger: "change",
        //   },
        // ],
        // operatorIdCardBack: [
        //   {
        //     required: true,
        //     message: "请上传经办人身份证国徽面照片",
        //     trigger: "change",
        //   },
        // ],
        // operatorName: [{required: true, message: "请输入经办人姓名", trigger: "blur"}],
        // operatorId: [{required: true, validator: validIdCard, trigger: "blur"}],
        // operatorPhone: [{required: true, validator: validPhone, trigger: "blur"}],
      },
      imageUrlOperatorFront: '',
      imageUrlOperatorReserve: '',

      visible: false,
      noticeVisible: false,
      count: 1616,
      timer: null,
      countdown: '',

      // 判断是否禁用的列表
      disbaleList: false,
      imageLicenseId: '',
      imageAuthorization: '',
      imageDigitalCertificateApplyForm: '',
      uploadType: ''
    }
  },
  mounted() {
    this.countDown()
    // this.getForm()
  },
  methods: {
    faceRecognition(idCard) {
      this.$refs.faceRef.show({...this.ruleForm, idCard: idCard}, "经办人");
    },
    getCheckId(checkId) {
      this.$set(this.ruleForm, "checkId", checkId);
    },
    uploadFiles(e) {
      if (e == 0) {
        this.getEncryptStr()
      } else if (e == 1 || e == 3) {
        this.$refs[this.uploadType].$refs['upload-inner'].handleClick()
      } else if (e == 2) {
        if (this.disbaleList) {
          this.$refs.IdCardComplete.show(this.ruleForm.idCard)
        } else {
          this.$refs.faceRef.show(this.ruleForm, "法人");
        }
      }
      this.visible = false
    },
    changeUpload(e) {
      if (e == 'idCardFrontId' || e == 'businessLicenseId' || e == 'operatorIdCardFront' || e == 'operatorIdCardBack') {
        if (typeof GSESC === 'object') {
          this.uploadType = e
          this.visible = true
        } else {
          this.$refs[e].$refs['upload-inner'].handleClick()
        }
      } else if (e == 'scene') {
        if (this.ruleForm.legalPersonName && this.ruleForm.legalPersonId) {
          this.uploadType = e
          this.visible = true
        } else {
          this.$refs[e].$refs['upload-inner'].handleClick()
        }
      }
      // this.getEncryptStr()
    },
    checkImage(flag) {
      this.srcList = [];
      if (flag == "front") {
        this.srcList.push(this.imageUrlFront);
      } else if (flag == "operatorFront") {
        this.srcList.push(this.imageUrlOperatorFront);
      } else if (flag == "operatorReserve") {
        this.srcList.push(this.imageUrlOperatorReserve);
      } else if (flag == "license") {
        this.srcList.push(this.imageLicenseId);
      } else if (flag == "reserve") {
        this.srcList.push(this.imageUrlReserve);
      } else if (flag == "auth") {
        this.srcList.push(this.imageAuthorization);
      } else {
        this.srcList.push(this.imageScene);
      }
      this.isShowPics = true;
    },
    handleBeforeUpload(file, type) {
      const reader = new FileReader();
      reader.readAsDataURL(file); // 转换为Base64
      reader.onload = (e) => {
        if (type == 0) {
          this.imageUrlOperatorFront = e.target.result;
        } else if (type == 1) {
          this.imageUrlOperatorReserve = e.target.result;
        } else if (type == 2) {
          this.imageLicenseId = e.target.result;
        } else if (type == 3) {
          this.imageAuthorization = e.target.result;
        } else if (type == 4) {
          this.imageDigitalCertificateApplyForm = e.target.result;
        }
        let position = e.target.result.indexOf("base64");
        let lastIndex = position * 1 + 7;
        let base = e.target.result.slice(lastIndex);
        this.request(base, type);
      };
      return false; // 阻止默认上传行为
    },
    request(base, type) {
      let params = {
        token: this.$route.params.id,
        fileType: '' + type,
        fileData: base,
      };
      this.loading = true;
      this.$http.post(this.$api.register.upload, params).then((res) => {
        if (res.data.code == 200) {
          this.loading = false;
        } else {
          this.$message.error(res.data.msg);
          this.loading = false;
        }
      });
    },
    countDown() {
      this.countdown = ''
      this.timer = setInterval(() => {
        if (this.count > 0 && this.count <= this.ruleForm.tokenExpire) {
          if (Math.floor(this.count % 60) < 10) {
            this.countdown = Math.floor(this.count / 60) + ':0' + Math.floor(this.count % 60)
          } else {
            this.countdown = Math.floor(this.count / 60) + ':' + Math.floor(this.count % 60)
          }
          this.count--;
        } else {
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },
    getForm() {
      this.loading = true
      this.$http.post(this.$api.digitalCertificate.initPage, {token: this.$route.params.id}).then(res => {
        if (res.data.code == 200) {
          this.ruleForm = res.data.data
          this.getDownApplyFile()
        } else {
          this.$message.error(res.data.msg)
          this.loading = false
        }
      })
    },
    getDownApplyFile() {
      let params = []
      // 0-身份证正面，1-身份证背面，2-营业执照，3-授权委托书，4-数字证书申请表
      if (this.ruleForm.certType == 0) {
        params = [0, 1, 4]
      } else {
        params = [0, 1, 2, 3, 4]
      }
      let le = 0
      this.downApplyFile(params, le)
    },
    downApplyFile(params, le) {
      this.$http.post(this.$api.digitalCertificate.downApplyFile, {
        token: this.$route.params.id,
        fileType: params[le]
      }).then(res => {
        if (res.data.code == 200) {
          if (params.length - 1 >= le) {
            this.downApplyFile(params, le++)
          }
        } else {

        }
      })
    },
    submitForm() {
      this.$refs.ruleForm.validate((value) => {
        if (value) {
          // this.loading = true
          this.noticeVisible = true
          // this.$http.post(this.$api.H5.createApply, JSON.stringify(this.ruleForm)).then(res => {
          //   if (res.data.code == 200) {
          //     // window.location.href = res.data.data.faceCertifyUrl
          //     this.$refs.faceRef.show({faceCertifyUrl: res.data.data.faceCertifyUrl, ...this.ruleForm}, "经办人");
          //     Cookies.set('PhysicalSeal', res.data.data.credential)
          //     this.loading = false
          //   } else {
          //     this.$message.error(res.data.msg)
          //     this.loading = false
          //   }
          // })
        }
      })
    },

    checkExampleDia() {
      this.$refs.checkRef.show("official");
    },
    onChangeFront(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },

    onChangeReserve(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
  }
})
</script>

<style scoped lang="less">
.upload-image {
  display: flex;
  align-items: flex-start;
  margin-bottom: 22px;

  .top-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100px;
  }
}

.avatar-uploader {
  position: relative;
  width: 210px;
  height: 160px;
  margin-right: 30px;
  background: #f5f7fa;
  border: 1px solid #f5f5f5;

  .image-card {
    height: 100%;
  }

  .icon-check {
    position: absolute;
    bottom: 0;
    right: 0;
  }
}

::v-deep .el-upload {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

//去掉number输入框的上下箭头
::v-deep input::-webkit-outer-spin-button {
  -webkit-appearance: none;
}

::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

::v-deep input[type="number"] {
  -moz-appearance: textfield;
}

// 解决input number框输入中文后光标上移的问题
::v-deep .el-input__inner {
  line-height: 1px !important;
}

::v-deep .el-form-item {
  margin-bottom: 28px !important;
}

::v-deep .el-form-item__error {
  text-align: left !important;
}
</style>
